import { CONTENT_ACTION_TYPES } from '../actions/types';

const initialState = {
  // Feed data
  feed: [],
  feedLoading: false,
  feedError: null,
  feedHasMore: true,
  feedPage: 0,
  feedRecordsTotal: 0,
  
  // Purchased content data
  purchasedContent: [],
  purchasedContentLoading: false,
  purchasedContentError: null,
  purchasedContentHasMore: true,
  purchasedContentPage: 0,
};

const contentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_ACTION_TYPES.FETCH_FEED_REQUEST:
      return {
        ...state,
        feedLoading: true,
        feedError: null,
      };

    case CONTENT_ACTION_TYPES.FETCH_FEED_SUCCESS:
      const newFeedData = action.payload.data || [];
      const isLoadMore = action.payload.isLoadMore || false;
      const limit = action.payload.limit || 6;
      
      // If we received fewer items than the limit, there's no more data
      const hasMore = newFeedData.length === limit;
      
      return {
        ...state,
        feedLoading: false,
        feed: isLoadMore ? [...state.feed, ...newFeedData] : newFeedData,
        feedHasMore: hasMore,
        feedPage: action.payload.page || 0,
        feedRecordsTotal: action.payload.recordsTotal || 0,
        feedError: null,
      };

    case CONTENT_ACTION_TYPES.FETCH_FEED_FAILURE:
      return {
        ...state,
        feedLoading: false,
        feedError: action.payload.error,
      };

    case CONTENT_ACTION_TYPES.FETCH_PURCHASED_CONTENT_REQUEST:
      return {
        ...state,
        purchasedContentLoading: true,
        purchasedContentError: null,
      };

    case CONTENT_ACTION_TYPES.FETCH_PURCHASED_CONTENT_SUCCESS:
      const newPurchasedData = action.payload.data || [];
      const isPurchasedLoadMore = action.payload.isLoadMore || false;
      const purchasedLimit = action.payload.limit || 6;
      
      // If we received fewer items than the limit, there's no more data
      const purchasedHasMore = newPurchasedData.length === purchasedLimit;
      
      return {
        ...state,
        purchasedContentLoading: false,
        purchasedContent: isPurchasedLoadMore ? [...state.purchasedContent, ...newPurchasedData] : newPurchasedData,
        purchasedContentHasMore: purchasedHasMore,
        purchasedContentPage: action.payload.page || 0,
        purchasedContentError: null,
      };

    case CONTENT_ACTION_TYPES.FETCH_PURCHASED_CONTENT_FAILURE:
      return {
        ...state,
        purchasedContentLoading: false,
        purchasedContentError: action.payload.error,
      };

    case CONTENT_ACTION_TYPES.UPDATE_FEED_ITEM: {
      const updatedPost = action.payload;

      const getComparableId = (post) =>
        post?._id || post?.content_id || post?.content?._id;

      const updatedPostId = getComparableId(updatedPost);

      if (!updatedPostId) {
        return state;
      }

      const mergePosts = (existingPost) => {
        const mergedPost = { ...existingPost, ...updatedPost };

        if (existingPost?.content || updatedPost?.content) {
          mergedPost.content = {
            ...(existingPost?.content || {}),
            ...(updatedPost?.content || {}),
          };
        }

        if (existingPost?.profile || updatedPost?.profile) {
          mergedPost.profile = {
            ...(existingPost?.profile || {}),
            ...(updatedPost?.profile || {}),
          };
        }

        return mergedPost;
      };

      let hasChanges = false;

      const nextFeed = state.feed.map((item) => {
        const itemId = getComparableId(item);
        if (itemId === updatedPostId) {
          hasChanges = true;
          return mergePosts(item);
        }
        return item;
      });

      if (!hasChanges) {
        return state;
      }

      return {
        ...state,
        feed: nextFeed,
      };
    }

    case CONTENT_ACTION_TYPES.CLEAR_CONTENT_ERRORS:
      return {
        ...state,
        feedError: null,
        purchasedContentError: null,
      };

    default:
      return state;
  }
};

export default contentReducer;

